const metaData = {
  description:
    "The latest Transfer Portal announcements, entries, and commits, and the exclusive Rivals Transfer Ranking",
  imageAlt: "Transfer Portal",
  imageUrl:
    "https://images.rivals.com/image/upload/f_auto,q_auto/zlstxnpmk1gwt6b8blli",
  title: "[year] college [sport] transfer portal activity tracker"
};

export default {
  editRankList: (sportName?: string): string =>
    `Edit Current ${sportName ? `${sportName} ` : ""}Rank List`,
  loadMoreText: "Load more athletes",
  metaData,
  pageTitle: "transfer tracker",
  philter: "transfer-tracker",
  rivalsLogoAlt: "Rivals",
  socialMediaPostText: "Transfer Tracker - Rivals",
  topAthletes: "top transfer portal athletes",
  transferRanking: "transfer ranking",
  viewAllTransferPortalPlayers: "View all transfer portal athletes",
  viewNationalTracker: "view national tracker"
};
